<template>
	<div>
		<div class="content ">
			<div class="tsfx">
				<div class="title u-text-center">行业新闻</div>
				<div class="title_tips u-text-center">行业大事小事全知道</div>
				<div class="news">
					<div class="newslit listHover" v-for="(item,index) in list" :key="index" @click="toDetails(item)">
						<div class="newst">
							<i class="news_icon">最新</i>
							<h3>{{item.title}}</h3>
						</div>
						<div class="nlc">
							<div class="news-c">
								<el-image fit="cover" :src="item.picture" />
							</div>
							<div class="news-r">
								<div class="tis">
									{{item.introduce}}
								</div>
								<div class="d-gray">{{item.createTime | dateFormat}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'homenews',
		components: {},
		data() {
			return {
				list: []
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			async getlist() {
				const res = await this.$axios.get('/front/listNews', {
					pageNum: 1,
					pageSize: 4,
					isTop: 0
				})
				this.list = res.rows
			},
			toDetails(item) {
				const {
					href
				} = this.$router.resolve({
					name: 'newsdetails',
					query: {
						newsId: item.newsId,
						picture: item.picture
					}
				})
				window.open(href, '_blank')
			},
		}
	}
</script>
<style lang="scss" scoped>
	.tsfx {
		padding: 100px 0 80px 0;
	}

	//新闻资讯
	.news {
		margin-top: 60px;

		.newslit {
			&:hover h3 {
				color: var(--brand);
			}

			background-color: var(--white);
			padding: 20px;
			margin-right: 2%;
			margin-bottom: 2%;
			width: 45.5%;
			float: left;
			border-radius: 4px;

			.newst {
				display: flex;
				align-items: center;

				.news_icon {
					padding: 2px 6px;
					border-radius: 4px;
					background-color: var(--brand);
					margin-right: 10px;
					color: var(--white);
				}
			}

			.nlc {
				margin-top: 20px;
				display: flex;

				.news-c {
					width: 200px;
					height: 140px;
					margin-right: 20px;

					.el-image {
						width: 100%;
						height: 100%;
						border-radius: 4px;
					}
				}

				.news-r {
					flex: 1;
					color: var(--tips);

					.tis {
						font-size: 16px;
						line-height: 30px;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
						display: -moz-box;
						-moz-line-clamp: 3;
						-moz-box-orient: vertical;
						overflow-wrap: break-word;
						word-break: break-all;
						white-space: normal;
						overflow: hidden;
						height: 90px;
						margin-bottom: 30px;


					}
				}

			}
		}

		.newslit:nth-child(2n) {
			margin-right: 0;
		}

		&:after {
			content: '';
			display: block;
			clear: both;
		}
	}
</style>
